const translationKeys = {
  savings_overview_total: 'savings_overview_total',
  savings_overview_title: 'savings_overview_title',
  savings_overview_accounts_title: 'savings_overview_accounts_title',
  savings_overview_accounts_total: 'savings_overview_accounts_total',
  savings_overview_accounts_loading_error:
    'savings_overview_accounts_loading_error',
  savings_overview_investments_title: 'savings_overview_investments_title',
  savings_overview_investments_total: 'savings_overview_investments_total',
  savings_overview_save_now_button: 'savings_overview_save_now_button',
  savings_overview_new_rule_button: 'savings_overview_new_rule_button',
  savings_overview_pension_title: 'savings_overview_pension_title',
  savings_overview_pension_loading_error:
    'savings_overview_pension_loading_error',
  savings_overview_funds_cell_title: 'savings_overview_funds_cell_title',
  savings_overview_stocks_cell_title: 'savings_overview_stocks_cell_title',
  savings_overview_pension_cell_title: 'savings_overview_pension_cell_title',
  savings_overview_investments_loading_error:
    'savings_overview_investments_loading_error',
  savings_overview_total_error_text: 'savings_overview_total_error_text',
  savings_overview_accounts_setup_button:
    'savings_overview_accounts_setup_button',
  savings_overview_accounts_setup_title:
    'savings_overview_accounts_setup_title',
  savings_overview_accounts_setup_subtitle:
    'savings_overview_accounts_setup_subtitle',
  savings_overview_pension_setup_section_title:
    'savings_overview_pension_setup_section_title',
  savings_overview_pension_setup_section_cell_title:
    'savings_overview_pension_setup_section_cell_title',
  savings_overview_pension_setup_section_line_text:
    'savings_overview_pension_setup_section_line_text',
  savings_overview_accounts_setup_remove_button:
    'savings_overview_accounts_setup_remove_button',
  savings_overview_investments_setup_section_title:
    'savings_overview_investments_setup_section_title',
  savings_overview_investments_setup_section_subtitle:
    'savings_overview_investments_setup_section_subtitle',
  savings_overview_investments_setup_funds_cell:
    'savings_overview_investments_setup_funds_cell',
  savings_overview_investments_setup_stocks_cell:
    'savings_overview_investments_setup_stocks_cell',
  savings_overview_accounts_setup_section_title:
    'savings_overview_accounts_setup_section_title',
  savings_overview_accounts_setup_section_line_text:
    'savings_overview_accounts_setup_section_line_text',
  savings_overview_accounts_setup_save_button:
    'savings_overview_accounts_setup_save_button',
  savings_header_breadcrumb_homepage: 'savings_header_breadcrumb_homepage',
  savings_overview_total_loading_text: 'savings_overview_total_loading_text',
};

Object.freeze(translationKeys);

export default translationKeys;
